import { isString } from "../utils/schemaUtils";

export interface GitHubRepo {
  id: string;
  fullName: string;
  private: boolean;
  archived: boolean;
}

const isGitHubRepo = (v: unknown): v is GitHubRepo => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.fullName) && typeof r.private === "boolean" && typeof r.archived === "boolean";
};

// The repositories the installation reaches, which an admin picks when
// installing the App on GitHub. Every other tool's repo argument comes from
// this set.
export interface GitHubReposPayload {
  type: "github_repos";
  account: string;
  repos: GitHubRepo[];
  hasMore: boolean;
}

export const parseGitHubReposPayload = (v: unknown): GitHubReposPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_repos") return null;
  if (!isString(r.account)) return null;
  if (!Array.isArray(r.repos) || !r.repos.every(isGitHubRepo)) return null;
  if (typeof r.hasMore !== "boolean") return null;
  return {
    type: "github_repos",
    account: r.account,
    repos: r.repos,
    hasMore: r.hasMore,
  };
};
